var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.current.title,
      staticClass: "w-100 h-100 d-flex flex-column justify-content-center"
    },
    [
      _c(
        "h3",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.current.title,
              expression: "current.title"
            }
          ],
          staticClass:
            "text-uppercase mb-5 font-family-alternative nav__modal-title"
        },
        [_vm._v("\n        " + _vm._s(_vm.current.title) + "\n    ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 col-md-10 col-lg-9 col-xl-8" }, [
            _c("div", { ref: "listContainer", staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 col-md-5" },
                _vm._l(_vm.left, function(element) {
                  return _c(
                    "div",
                    {
                      staticClass: "secondary-text nav__link",
                      class: { huge: element.huge }
                    },
                    [
                      _c(
                        "app-link",
                        {
                          attrs: {
                            href: element.url || "#",
                            child: element.child
                          },
                          on: {
                            click: function($event) {
                              return _vm.navigate(element, $event)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(element.name) +
                              "\n                            "
                          )
                        ]
                      )
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-md-5 offset-md-2" },
                _vm._l(_vm.right, function(element) {
                  return _c(
                    "div",
                    {
                      staticClass: "secondary-text nav__link",
                      class: { huge: element.huge }
                    },
                    [
                      _c(
                        "app-link",
                        {
                          attrs: {
                            href: element.url || "#",
                            child: element.child
                          },
                          on: {
                            click: function($event) {
                              return _vm.navigate(element, $event)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(element.name) +
                              "\n                            "
                          )
                        ]
                      )
                    ],
                    1
                  )
                }),
                0
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }